import { VueModule } from '@Foundation';
import ProvenEfficacy from './code/Scripts/components/proven-efficacy';

export default VueModule({
  components: {
    ProvenEfficacy
  }
});
